/**
 * Posun na první chybu ve formuláři.
 *
 * Wizard dosud po neúspěšné validaci jen tiše skončil (`if (!validate()) return`).
 * Hláška se přitom objevila u pole nahoře, zatímco tlačítko Pokračovat je dole
 * mimo obrazovku, takže to na uživatele působilo, jako by tlačítko nefungovalo.
 * Při průchodu portálem to zastavilo postup hned na dvou krocích.
 */

const SELEKTOR = '.chyba-pole';

/**
 * Najde první viditelnou hlášku, odroluje k ní a zaostří příslušné pole.
 *
 * Volá se hned po `setErrors`, jenže React stav překresluje až v dalším
 * cyklu, takže v tu chvíli hlášky v DOM ještě nejsou. Proto se čeká na
 * dvojí snímek: první doběhne aktuální práce, ve druhém je už vykresleno.
 */
export function posunNaChybu() {
  if (typeof window === 'undefined') return;
  window.requestAnimationFrame(() => window.requestAnimationFrame(_posun));
}

function _posun() {
  if (typeof document === 'undefined') return false;

  const hlaska = Array.from(document.querySelectorAll(SELEKTOR))
    .find(el => el.offsetParent !== null);
  if (!hlaska) return false;

  const skupina = hlaska.closest('.form-group') || hlaska.parentElement;
  const cil = skupina || hlaska;

  cil.scrollIntoView({ behavior: 'smooth', block: 'center' });

  // Zaostření až po doskrolování, jinak prohlížeč skok zopakuje.
  const pole = skupina && skupina.querySelector('input, select, textarea');
  if (pole) {
    window.setTimeout(() => {
      try { pole.focus({ preventScroll: true }); } catch (e) { pole.focus(); }
    }, 350);
  }
  return true;
}

export default posunNaChybu;
